export const socialsData = {
    github: 'https://github.com/notsammy002',
    linkedIn: 'https://www.linkedin.com/in/samuel-yadav-03912417b/',
    codepen: 'https://codesandbox.io/u/notsammy002',
}